import { Button } from '@/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/dropdown';
import { Table } from '@/components/table';
import { tickets } from '@/reducers/tickets';
import { AppDispatch } from '@/root/store';
import { FormatCurrency } from '@/routes/root';
import { ShowEvent } from '@/services/events';
import { UpdateTicketStatus } from '@/services/tickets';
import {
  EllipsisHorizontalIcon,
  PencilSquareIcon,
  TrashIcon,
} from '@heroicons/react/24/outline';
import moment from 'moment';
import { InputSwitch } from 'primereact/inputswitch';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

export interface TicketProps {
  title: React.ReactNode;
  button?: React.ReactNode;
  mode?: 'edit' | 'info';
  data: any;
  onEditTicketClicked?: any;
  onDeleteTicketClicked?: any;
}

export const TicketList: React.FC<TicketProps> = ({
  title,
  button,
  data,
  onEditTicketClicked,
  onDeleteTicketClicked,
  mode = 'edit',
}) => {
  const { slug } = useParams();
  const dispatch: AppDispatch = useDispatch();
  const [showCinema, setShowCinema] = useState(false);
  const { event } = useSelector((state: any) => state.event);

  useEffect(() => {
    setShowCinema(event.type === 'cinema' && mode === 'info');
  }, [event]);

  const toggleTicket = (id: string) => {
    const selectedTicket = data?.filter((ticket: any) => ticket.id === id)?.[0];
    if (selectedTicket) {
      let newSelectedTicket = {
        ...selectedTicket,
        is_open: !selectedTicket.is_open,
      };

      let ticketsData = data.map((ticket: any) =>
        ticket.id === id ? newSelectedTicket : ticket
      );

      dispatch(
        UpdateTicketStatus(newSelectedTicket.id, newSelectedTicket.is_open)
      );

      dispatch(tickets(ticketsData));
    }
  };

  return (
    <>
      <div className='flex flex-col gap-6'>
        <div className='flex items-center'>
          {title}
          {button}
        </div>
        <Table className='overflow-scroll whitespace-nowrap md:whitespace-normal'>
          <thead>
            <tr>
              <th>No.</th>
              <th>Kode tiket</th>
              <th>Nama tiket</th>

              {showCinema && <th>Studio</th>}
              {showCinema && <th>Jam Tayang</th>}

              <th>Harga</th>
              <th>Jumlah tiket {mode === 'info' && 'terjual'}</th>
              {mode === 'info' && <th>Jumlah tiket belum dibayar</th>}
              <th>Visibilitas</th>
              <th>Tgl jual</th>
              {mode === 'info' && event.type !== 'cinema' && <th>Status</th>}
              {mode === 'edit' && <th>Aksi</th>}
            </tr>
          </thead>
          <tbody>
            {data.map((ticket: any, index: string) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{ticket.code}</td>
                <td>{ticket.name}</td>

                {showCinema && <td>{ticket.studio_name}</td>}
                {showCinema && <td>{ticket.time}</td>}

                <td>
                  <span className='text-danger'>
                    <FormatCurrency
                      amount={ticket.price}
                      currency={ticket.currency_code}
                    />
                  </span>
                </td>
                <td>
                  {mode === 'info' && (
                    <span className={'text-red-500'}>
                      {ticket.number_tickets_sold}/
                    </span>
                  )}
                  {ticket.quantity}
                </td>
                {mode === 'info' && (
                  <td>
                    <span className={'text-red-500'}>
                      {ticket.number_tickets_onhold}
                    </span>
                  </td>
                )}
                <td>{ticket.saleable_label}</td>
                <td>
                  {moment(ticket.start_sell_at).format('lll')} -{' '}
                  {moment(ticket.end_sell_at).format('lll')}
                </td>
                {mode === 'info' && event.type !== 'cinema' && (
                  <td>
                    <div>
                      <InputSwitch
                        pt={{
                          slider: {
                            className: ticket.is_open ? 'bg-primary' : '',
                          },
                        }}
                        checked={ticket.is_open}
                        onChange={() => toggleTicket(ticket.id)}
                      />
                    </div>
                  </td>
                )}
                {mode === 'edit' && (
                  <td>
                    <DropdownMenu>
                      <DropdownMenuTrigger>
                        <Button
                          size='sm'
                          variant='neutral'
                          leftIcon={<EllipsisHorizontalIcon />}
                        />
                      </DropdownMenuTrigger>
                      <DropdownMenuContent>
                        <DropdownMenuItem
                          className={'cursor-pointer'}
                          onClick={() => {
                            onEditTicketClicked(ticket.id);
                          }}
                        >
                          <PencilSquareIcon className='mr-2 h-4 w-4' />
                          <span>Ubah</span>
                        </DropdownMenuItem>
                        <DropdownMenuItem
                          className={'cursor-pointer'}
                          onClick={() => {
                            onDeleteTicketClicked(ticket.id);
                          }}
                        >
                          <TrashIcon className='mr-2 h-4 w-4 text-danger' />
                          <span className='text-danger'>Hapus</span>
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </>
  );
};
